import { TABLE_PARAMETERS, resolveTableParams } from './resolveTableParams'

export const dataGridVariants = {
  default: {
    code: 'default',
    displayName: 'Default',
    description: 'Standard data grid with neutral depth-banded rows, bordered column headers, and semantic table color tokens.',
    parameters: TABLE_PARAMETERS,
    resolve: (params) => resolveTableParams(params)
  },
  flat: {
    code: 'flat',
    displayName: 'Flat',
    description: 'Clean, minimal grid with no column-group borders. Good for simple single-level data.',
    parameters: TABLE_PARAMETERS,
    resolve: (params) => resolveTableParams(params)
  },
  glass: {
    code: 'glass',
    displayName: 'Glass',
    description: 'Translucent frosted-glass effect with rounded corners and subtle shadow. Works best on colored or image backgrounds.',
    parameters: TABLE_PARAMETERS,
    resolve: (params) => resolveTableParams(params)
  },
  legacy: {
    code: 'legacy',
    displayName: 'Legacy',
    description: 'Classic grid style with full cell borders and darker depth progression. Matches the original performance table look.',
    parameters: TABLE_PARAMETERS,
    resolve: (params) => resolveTableParams(params)
  }
}
